// Ortak para/tutar biçimlendirme yardımcıları.
// Uygulama genelinde tutarlı Türkçe para formatı (1.500,00 ₺) sağlar.

// Döviz kodu -> sembol eşlemesi. Bilinmeyen kodlar olduğu gibi (kod olarak) gösterilir.
const DOVIZ_SEMBOL = {
  TRY: '₺',
  TL: '₺',
  '₺': '₺',
  USD: '$',
  '$': '$',
  EUR: '€',
  '€': '€',
  GBP: '£',
  '£': '£',
};

/**
 * Bir tutarı Türkçe biçimde (bin ayracı + 2 ondalık) ve döviz sembolü ile biçimlendirir.
 * @param {number|string} value Ham tutar.
 * @param {string} [currency='TRY'] Döviz kodu veya sembolü (TRY, USD, EUR, ₺, $ ...).
 * @param {object} [opts]
 * @param {string} [opts.empty='-'] value boş/geçersizse dönecek değer.
 * @param {number} [opts.fractionDigits=2] Ondalık basamak sayısı.
 * @returns {string} Örn. "1.500,00 ₺"
 */
export const formatMoney = (value, currency = 'TRY', opts = {}) => {
  const { empty = '-', fractionDigits = 2 } = opts;
  if (value === null || value === undefined || value === '') return empty;
  const num = typeof value === 'number' ? value : parseFloat(String(value).replace(/\s/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'));
  if (!isFinite(num) || isNaN(num)) return empty;

  const formatted = num.toLocaleString('tr-TR', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

  const code = (currency || 'TRY').toString().trim();
  const symbol = DOVIZ_SEMBOL[code] || DOVIZ_SEMBOL[code.toUpperCase()] || code;
  return symbol ? `${formatted} ${symbol}`.trim() : formatted;
};

/**
 * Sembolsüz Türkçe sayı biçimi (bin ayracı nokta, ondalık virgül).
 * Para kolonu olup sembol istemeyen tablolar için (örn. Mali Rapor özetleri).
 * @returns {string} Örn. "1.500,00"
 */
export const formatNumberTR = (value, fractionDigits = 2, empty = '-') => {
  // formatMoney('') currency'yi TRY sayıp '₺' ekliyordu; burada sembol istenmez.
  if (value === null || value === undefined || value === '') return empty;
  const num = typeof value === 'number' ? value : parseFloat(String(value).replace(/\s/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'));
  if (!isFinite(num) || isNaN(num)) return empty;
  return num.toLocaleString('tr-TR', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });
};

/**
 * antd InputNumber için Türkçe para girişi propları:
 *   <InputNumber {...inputNumberMoneyProps} />
 * Görüntü: 1.234,56 (bin ayracı NOKTA, ondalık VİRGÜL) — parser bunu sayıya çevirir.
 * (Önceki EN stili formatter'lar '12,5' girişindeki virgülü silip 125 yapıyordu.)
 */
export const inputNumberMoneyProps = {
  formatter: (value) => {
    if (value === null || value === undefined || value === '') return '';
    const [tam, ondalik] = String(value).split('.');
    const tamTR = tam.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return ondalik !== undefined ? `${tamTR},${ondalik}` : tamTR;
  },
  parser: (value) =>
    String(value || '')
      .replace(/\s|₺|\$|€|£/g, '')
      .replace(/\./g, '')
      .replace(',', '.'),
  decimalSeparator: ',',
};

export default formatMoney;
